import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {useTemplatedComponent} from "@next/templating"
import {useReadFeatureSetting} from "../../../contexts/useReadFeatureSetting"
import {FeatureSettingKeys} from "../../../models/FeatureFlags"
import connect from "./connect"

interface FavouritesContainerProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    favouriteBtnEnabled: boolean
    enableSingleLineTitle: boolean
    children: React.ReactNode
    suppressHydrationWarning?: boolean
}

export const FavouritesContainer = memo(
    ({
        templating,
        favouriteBtnEnabled,
        enableSingleLineTitle,
        children,
        suppressHydrationWarning,
    }: FavouritesContainerProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const enableFavourites = useReadFeatureSetting(FeatureSettingKeys.enableFavourites)
        const showFavourites = enableFavourites && favouriteBtnEnabled
        if (!showFavourites) {
            return null
        }
        return (
            <ComponentName
                suppressHydrationWarning
                className="product-summary-favourites-container"
                data-testid="product-summary-favourites-button-container"
                $enableSingleLineTitle={enableSingleLineTitle}
            >
                {children}
            </ComponentName>
        )
    },
)

FavouritesContainer.displayName = "FavouritesContainer"
export default connect(FavouritesContainer)
